<h1>My Workout Plan</h1>
<section id="bodybuilding-workout-plan">
<h2>My Bodybuilding Workout Plan</h2>
<p class="bodybuilding-workouts" id="bodybuilding-workouts"></p>
<div class="row">
<ng-container *ngFor="let workout of bodybuildingWorkoutPlan">
    <div class="col-lg-3">
    <h3>{{workout.day}}</h3>
    <h3>{{workout.workoutType}}</h3>
    <ul>
        <li>{{workout.workout1}}</li>
        <li>{{workout.workout2}}</li>
        <li>{{workout.workout3}}</li>
        <li>{{workout.workout4}}</li>
        <li>{{workout.workout5}}</li>
    </ul>
    </div>
</ng-container>
</div>
</section>

<section id="strength-workout-plan">
    <h2>My Strength Workout Plan</h2>
    <p class="strength-workouts" id="strength-workouts"></p>
    <div class="row">
    <ng-container *ngFor="let workout of strengthWorkoutPlan">
        <div class="col-lg-4">
        <h3>{{workout.day}}</h3>
        <h3>{{workout.workoutType}}</h3>
        <ul>
            <li>{{workout.workout1}}</li>
            <li>{{workout.workout2}}</li>
            <li>{{workout.workout3}}</li>
            <li>{{workout.workout4}}</li>
            <li>{{workout.workout5}}</li>
        </ul>
        </div>
    </ng-container>
    </div>
</section>
    
<section id="functional-workout-plan">
    <h2>My Functional Workout Plan</h2>
    <p class="functional-workouts" id="functional-workouts"></p>
    <div class="row">
    <ng-container *ngFor="let workout of functionalWorkoutPlan">
        <div class="col-lg-4">
        <h3>{{workout.day}}</h3>
        <h3>{{workout.workoutType}}</h3>
        <ul>
            <li>{{workout.workout1}}</li>
            <li>{{workout.workout2}}</li>
            <li>{{workout.workout3}}</li>
            <li>{{workout.workout4}}</li>
            <li>{{workout.workout5}}</li>
        </ul>
        </div>
    </ng-container>
    </div>
</section>
<section>
    <h2>Ready to Run Fast?</h2>
    <p>In addition to these workout plans, we have also provided you with running plans!</p>
    <a routerLink='/your-running-workout-plan'><button id="checkout-running-workout-plans-btn">Checkout our Running Plans</button></a>
</section>